import React from "react";
import { NoDataIcon } from "../../icon";

interface IProps {
    Icon?: any;
    Classname?: string;
    Message: any;
}


const NoDataComponent: React.FC<IProps> = (props: IProps) => {

    return (
        <div className="w-p-100 h-p-100 d-flex flex-direction justify-between">
            <div className="w-p-100 h-8 d-flex align-center justify-center mt-2">
                <div className="d-flex align-center justify-center bg-color-channel-dashboard-total-tickets h-p-100 br-2 flex-1 px-2 mx-2 h5-medium b-primary-light">
                    {props.Message}
                </div>
            </div>
            <div className="w-p-100 mt-auto">
                <NoDataIcon className="w-p-100"/>
            </div>
        </div>
    )
}

export default NoDataComponent;